import { useEffect, useRef } from "react";

export function useRafThrottle<T>(callback: (value: T) => void) {
  const rafRef = useRef<number | null>(null);
  const pendingRef = useRef<T | null>(null);
  const hasPendingRef = useRef(false);
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  useEffect(
    () => () => {
      if (rafRef.current !== null) cancelAnimationFrame(rafRef.current);
    },
    []
  );

  return (value: T) => {
    pendingRef.current = value;
    hasPendingRef.current = true;
    if (rafRef.current !== null) return;
    rafRef.current = requestAnimationFrame(() => {
      rafRef.current = null;
      if (!hasPendingRef.current) return;
      hasPendingRef.current = false;
      callbackRef.current(pendingRef.current as T);
    });
  };
}
